import { useContext, useEffect, useState } from 'react';

import Table from '../../ui/Table';

import { getBounties, publishOrUnpublishBounty, getBountiesCount } from '../../apis/bounties/bounties';
import { useNavigate, useParams } from 'react-router-dom';
import AvatarImage from '../../ui/AvatarImage';
import Menus from '../../ui/Menus';

import DeleteIcon from '../../assets/icons/DeleteIcon';
import DeleteBountyModal from './DeleteBountyModal';
import DuplicateMenuIcon from '../../assets/icons/DuplicateMenuIcon';
import PublishMenuIcon from '../../assets/icons/PublishMenuIcon';

import EditMenuIcon from '../../assets/icons/EditMenuIcon';
import DuplicateBountyModal from './DuplicateBountyModal';
import Input from '../../ui/Input';
import search from '../../assets/search.png';

import { BOUNTY_STATUS_TAG_COLOR } from '../../constants/datas';
import { useLoadingState } from '../../hooks/useLoader';
import Loader from '../../ui/Loader';
import NoDataAvailable from '../../ui/NoDataAvailable';
import RequestTreasuryApprovalModal from './RequestTreasuryApprovalModal';
import PopOver from '../../ui/PopOver';
import { toast } from 'sonner';
import StartBountyModal from './StartBountyModal';
import { AuthContext } from '../../contexts/AuthContext';
import TruncatedTextWithTooltip from '../../ui/TruncatedTextWithTooltip';
import TabSwitching from '../../ui/TabSwitching';
import ToastIcon from '../../assets/icons/ToastIcon';
import WithdrawIcon from '../../assets/icons/WithdrawIcon';
import WithdrawBountyModal from './WithdrawBountyModal';

import { useActiveProjectsEvents } from '../../hooks/useActiveProjectsEvents';
import ForcefullyExpireBountyModal from './ForcefullyExpireBounty';
import ExpireBountyIcon from '../../assets/icons/ExpireBountyIcon';
import ExtendBountyDateModal from './ExtendBountyDateModal';
import RePublishBountyModal from './RePublishBountyModal';
import RePublishBountyIcon from '../../assets/icons/RePublishBountyIcon';
import ExtendBountyDateIcon from '../../assets/icons/ExtendBountyDateIcon';
import Pagination from '../../ui/Pagination';

function BountiesList() {
    const [bounties, setBounties] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [totalEntries, setTotalEntries] = useState(0);
    const [entriesPerPage, setEntriesPerPage] = useState(10);
    const [searchString, setSearchString] = useState('');
    const [activeTab, handleActiveTab] = useActiveProjectsEvents('Projects', true, 'bountyTab');
    const { loading, startLoading, stopLoading } = useLoadingState();
    const { state } = useContext(AuthContext);
    const { user } = state;
    const userProfile = user[0];
    const [isModalOpen, setModalOpen] = useState(false); // Modal visibility state
    const [modalAction, setModalAction] = useState(''); // Track action type: 'duplicate' or 'delete'
    const [selectedBounty, setSelectedBounty] = useState(null); // Track selected bounty for modal
    const { id } = useParams();
    const navigate = useNavigate();
    let filteredData = bounties;
    useEffect(
        function () {
            const fetchData = async () => {
                try {
                    startLoading();
                    const queryParams = {};
                    if (activeTab === 'Projects') {
                        queryParams.includeProjectBounties = true;
                        queryParams.includeIndividualBounties = true;
                    } else if (activeTab === 'Events') {
                        queryParams.includeEventBounties = true;
                    }

                    const countData = await getBountiesCount(id, queryParams);
                    setTotalEntries(countData?.entryCount || 0);
                    const data = await getBounties(id, currentPage, entriesPerPage, queryParams);
                    setBounties(data);
                    stopLoading();
                } catch (error) {
                    console.log(error);
                }
            };
            fetchData();
        },
        [id, currentPage, entriesPerPage, activeTab]
    );

    const entriesHandler = (val) => {
        setEntriesPerPage(val);
        setCurrentPage(1);
    };

    const handleTogglePublish = async (oppStatus, id) => {
        try {
            const afterToggling = bounties.map((bounty) => {
                if (bounty._id === id) return { ...bounty, status: oppStatus };
                return bounty;
            });
            setBounties(afterToggling);
            const res = await publishOrUnpublishBounty(id);
        } catch (error) { }
    };

    const handleOpenModal = (action, bounty) => {
        setModalAction(action); // Set the action type ('duplicate' or 'delete')
        setSelectedBounty(bounty); // Set the selected bounty
        setModalOpen(true); // Open the modal
    };

    const handleCloseModal = () => {
        setModalOpen(false); // Close the modal
        setModalAction(''); // Clear action type
        setSelectedBounty(null); // Clear selected bounty
    };

    const handleConfirmAction = (newBounty, newStatus) => {
        console.log({ newBounty, newStatus }, 'newBounty,newStatus');
        if (modalAction === 'duplicate') {
            setBounties((prev) => {
                const index = prev.findIndex((bounty) => bounty._id === selectedBounty._id);
                const updatedBounties = [...prev];
                updatedBounties.splice(index + 1, 0, {
                    ...newBounty,
                    creatorProfileImage: userProfile?.profileImage,
                    creatorUsername: userProfile?.userName,
                    projectTitle: selectedBounty?.projectTitle,
                }); // Insert the duplicate right after the original
                return updatedBounties;
            });
            // Perform duplication logic here
        } else if (modalAction === 'delete') {
            setBounties((prev) => prev.filter((bounty) => bounty._id !== selectedBounty._id));
        } else if (modalAction === 'request') {
            setBounties((prev) =>
                prev.map((bounty) => {
                    if (bounty._id === selectedBounty._id) {
                        return { ...bounty, status: 'Creation Requested' };
                    }
                    return bounty;
                })
            );
        } else if (modalAction === 'withdraw') {
            setBounties((prev) =>
                prev.map((bounty) => {
                    if (bounty._id === selectedBounty._id) {
                        return { ...bounty, status: 'Draft' };
                    }
                    return bounty;
                })
            );
        } else if (modalAction === 'start') {
            setBounties((prev) =>
                prev.map((bounty) => {
                    if (bounty._id === selectedBounty._id) {
                        return { ...bounty, status: 'Live and Published' };
                    }
                    return bounty;
                })
            );
        }
        else if (modalAction === 'expire') {
            setBounties((prev) =>
                prev.map((bounty) => {
                    if (bounty._id === selectedBounty._id) {
                        return { ...bounty, status: newStatus };
                    }
                    return bounty;
                })
            );
        }
        else if (modalAction === 'extend') {
            setBounties((prev) =>
                prev.map((bounty) => {
                    if (bounty._id === selectedBounty._id) {
                        return { ...bounty };
                    }
                    return bounty;
                })
            );
        }
        else if (modalAction === 'republish') {
            setBounties((prev) =>
                prev.map((bounty) => {
                    if (bounty._id === selectedBounty._id) {
                        return { ...bounty, status: "Live and Published" };
                    }
                    return bounty;
                })
            );
        }
        handleCloseModal();
    };

    if (searchString) {
        filteredData = filteredData.filter(({ title, projectTitle }) => {
            return (
                title?.toLowerCase()?.includes(searchString.toLowerCase()) ||
                projectTitle?.toLowerCase()?.includes(searchString.toLowerCase())
            );
        });
    }
    console.log(bounties, filteredData, 'implementing forcefully expire bounty');
    return (
        <>
            <Menus>
                <Table whiteCardClassName="" className="gap-8 " cols="grid-cols-tableBounties">
                    <Table.Description
                        description="Bounties"
                        primaryBtn="+ Add Bounty"
                        clickOnPrimary={() => navigate(`/${id}/createBounty`)}
                    />
                    <div className="flex gap-10 mb-4 ">
                        <TabSwitching
                            activeTab={activeTab}
                            onSelectingActive={(val) => {
                                handleActiveTab(val);
                                setCurrentPage(1);
                            }}
                            firstTab={'Projects'}
                            secondTab={'Events'}
                            activeStyling={'text-textBrandBlue border-b-2 border-textBrandBlue '}
                            className={'text-xl font-medium pb-2'}
                        />
                    </div>
                    <div className="flex items-center w-[441px] gap-3 py-2 px-3 mb-4 border border-borderUnderline rounded-lg ">
                        <img className="w-6 h-6  object-cover" src={search} alt="" />
                        <Input
                            value={searchString}
                            onChange={(e) => setSearchString(e.target.value)}
                            placeholder="Search Bounty Title or Project Title"
                            className=" !w-full !border-0 !px-0 !py-0 outline-none "
                            containerClass="flex-1"
                            type="text"
                        />
                    </div>

                    <Table.Header>
                        <p className="text-sm justify-self-start  font-semibold text-textSecondary ">Bounty ID</p>
                        <p className="text-sm font-semibold text-textSecondary ">Bounty Title</p>
                        <p className="text-sm  font-semibold text-textSecondary ">
                            {' '}
                            <span> {activeTab === 'Projects' ? 'Project Title' : 'Event Title'} </span>{' '}
                        </p>
                        <p className="text-sm  font-semibold text-textSecondary ">Status</p>
                        <p className="text-sm  font-semibold text-textSecondary ">Created By</p>
                    </Table.Header>
                    {loading ? (
                        <div className="min-h-[20vh] flex justify-center items-center">
                            <Loader />
                        </div>
                    ) : filteredData.length ? (
                        filteredData.map((bounty) => (
                            <Table.Row key={bounty._id} rowClassName="relative">
                                <div className=" cursor-pointer  w-full overflow-hidden uppercase self-center font-medium">
                                    <TruncatedTextWithTooltip
                                        onClick={() => navigate(`${bounty._id}${bounty?.eventName ? `?eventName=${bounty.eventName}` : ""}`)}
                                        textClassName={'text-textBrandBlue   uppercase cursor-pointer font-medium'}
                                        text={bounty?._id}
                                    />
                                </div>
                                <TruncatedTextWithTooltip
                                    containerClassName={'self-center'}
                                    textClassName="text-textPrimary"
                                    text={bounty.title}
                                />
                                <TruncatedTextWithTooltip
                                    onClick={() => {
                                        if (bounty.projectId)
                                            navigate(`/organizations/${id}/view-projects/${bounty.projectId}`);

                                    }}
                                    containerClassName={'self-center'}
                                    textClassName={`${bounty?.projectTitle ? "text-textBrandBlue  truncate cursor-pointer" : "text-textPrimary  truncate"}  `}
                                    text={bounty.projectTitle || bounty?.eventName || "-"}
                                />

                                {/* <Tag
                                    rounded="rounded-lg "
                                    className="px-2 py-1 leading-3 self-center   "
                                    textClassName="text-xs font-semibold"
                                    bg={BOUNTY_STATUS_TAG_COLOR[bounty.status]?.bg}
                                    textColor={BOUNTY_STATUS_TAG_COLOR[bounty.status]?.text}
                                    text={bounty.status}
                                /> */}
                                <PopOver
                                    rounded="rounded-lg "
                                    isValidationRequested={bounty?.status === "Validation Requested"}
                                    isCreationRequested={bounty?.status === "Creation Requested"}
                                    className="px-2 py-1 leading-3 self-center   "
                                    textClassName="text-xs font-semibold"
                                    bg={BOUNTY_STATUS_TAG_COLOR[bounty.status]?.bg}
                                    textColor={BOUNTY_STATUS_TAG_COLOR[bounty.status]?.text}
                                    borderColor={BOUNTY_STATUS_TAG_COLOR[bounty.status]?.border}
                                    text={bounty.status}
                                    active={
                                        bounty.status === 'Live and Published' ||
                                            bounty.status === 'Live and Unpublished'
                                            ? 'Live'
                                            : bounty.status
                                    }
                                />
                                <div className="flex items-center gap-4 ">
                                    <AvatarImage w="w-8" h="h-8" url={bounty.creatorProfileImage} />
                                    <p className="text-textPrimary  ">{bounty.creatorUsername}</p>
                                </div>

                                <Menus.Toggle id={bounty._id} />
                                <Menus.List id={bounty._id}>
                                    {bounty?.receivedSubmissions && (["Draft", "Live and Published", "Live and Unpublished"]?.includes(bounty?.status)) && (
                                        <p className="w-72 text-sm py-3 px-4 flex items-center gap-2 shrink-0">
                                            <span className="flex-shrink-0">
                                                <ToastIcon className="flex-shrink-0" />
                                            </span>
                                            You can't edit this bounty since it has started to receive submissions
                                        </p>
                                    )}

                                    {/* Delete Action */}
                                    {bounty.status === 'Draft' && (
                                        <>
                                            <Menus.Button
                                                width="w-full"
                                                disabled={bounty?.receivedSubmissions}
                                                menuBtnClassName={` ${bounty?.receivedSubmissions ? 'cursor-not-allowed ' : ''
                                                    }`}
                                                onClick={() => navigate(`/${id}/createBounty?bountyId=${bounty._id}${bounty?.eventName ? `&eventName=${bounty.eventName}` : ""}`)}
                                                icon={<EditMenuIcon />}
                                            >
                                                Edit
                                            </Menus.Button>
                                            <Menus.Button
                                                width="w-full"
                                                onClick={(fn) => {
                                                    handleOpenModal('delete', bounty);
                                                    fn();
                                                }}
                                                icon={<DeleteIcon />}
                                            >
                                                Delete
                                            </Menus.Button>
                                        </>
                                    )}
                                    {/* {bounty.status === 'Draft' && (
                                        <Menus.Button
                                         width="w-full"
                                            onClick={(fn) => {
                                                handleOpenModal('request', bounty);
                                                fn();
                                            }}
                                            icon={<RequestTreasuryMenuIcon />}
                                        >
                                            Request Treasury Approval
                                        </Menus.Button>
                                    )} */}
                                    {bounty.status === 'Live and Published' && (
                                        <>
                                            <Menus.Button
                                                width="w-full"
                                                disabled={bounty?.receivedSubmissions}
                                                menuBtnClassName={` ${bounty?.receivedSubmissions ? 'cursor-not-allowed ' : ''
                                                    }`}
                                                onClick={(fn) => {
                                                    toast.error('Please unpublish the bounty first');
                                                    fn();
                                                }}
                                                icon={<EditMenuIcon />}
                                            >
                                                Edit
                                            </Menus.Button>
                                            <Menus.Button
                                                width="w-full"
                                                onClick={() => handleTogglePublish('Live and Unpublished', bounty._id)}
                                                icon={<PublishMenuIcon />}
                                            >
                                                Unpublish
                                            </Menus.Button>
                                            <Menus.Button
                                                width="w-full"
                                                onClick={(fn) => {
                                                    handleOpenModal('expire', bounty);
                                                    fn();
                                                }}
                                                icon={<ExpireBountyIcon />}
                                            >
                                                Forcefully Expire <br /> Bounty
                                            </Menus.Button>
                                            <Menus.Button
                                                width="w-full"
                                                onClick={(fn) => {
                                                    handleOpenModal('extend', bounty);
                                                    fn();
                                                }}
                                                icon={<ExtendBountyDateIcon />}
                                            >
                                                Extend Bounty <br /> Date
                                            </Menus.Button>
                                        </>
                                    )}
                                    {bounty.status === 'Live and Unpublished' && (
                                        <>
                                            <Menus.Button
                                                width="w-full"
                                                disabled={bounty?.receivedSubmissions}
                                                menuBtnClassName={` ${bounty?.receivedSubmissions ? 'cursor-not-allowed ' : ''
                                                    }`}
                                                onClick={() => navigate(`/${id}/createBounty?bountyId=${bounty._id}${bounty?.eventName ? `&eventName=${bounty.eventName}` : ""}${bounty?.eventName ? `&eventName=${bounty.eventName}` : ""}`)}
                                                icon={<EditMenuIcon />}
                                            >
                                                Edit
                                            </Menus.Button>

                                            <Menus.Button
                                                width="w-full"
                                                onClick={() => handleTogglePublish('Live and Published', bounty._id)}
                                                icon={<PublishMenuIcon />}
                                            >
                                                Publish
                                            </Menus.Button>

                                            {!bounty?.receivedSubmissions && (
                                                <Menus.Button
                                                    width="w-full"
                                                    onClick={(fn) => {
                                                        handleOpenModal('delete', bounty);
                                                        fn();
                                                    }}
                                                    icon={<DeleteIcon />}
                                                >
                                                    Delete
                                                </Menus.Button>
                                            )}
                                            <Menus.Button
                                                width="w-full"
                                                onClick={(fn) => {
                                                    handleOpenModal('expire', bounty);
                                                    fn();
                                                }}
                                                icon={<ExpireBountyIcon />}
                                            >
                                                Forcefully Expire <br /> Bounty
                                            </Menus.Button>
                                            <Menus.Button
                                                width="w-full"
                                                onClick={(fn) => {
                                                    handleOpenModal('extend', bounty);
                                                    fn();
                                                }}
                                                icon={<ExtendBountyDateIcon />}
                                            >
                                                Extend Bounty <br /> Date
                                            </Menus.Button>
                                        </>
                                    )}



                                    <Menus.Button
                                        width="w-full"
                                        shouldCloseMenu={true}
                                        onClick={(fn) => {
                                            handleOpenModal('duplicate', bounty);
                                            fn();
                                        }}
                                        icon={<DuplicateMenuIcon />}
                                    >
                                        Duplicate
                                    </Menus.Button>
                                    {
                                        bounty?.status === "Unvalidated" && (
                                            <>

                                                <Menus.Button
                                                    width="w-full"
                                                    onClick={(fn) => {
                                                        handleOpenModal('republish', bounty);
                                                        fn();
                                                    }}
                                                    icon={<RePublishBountyIcon />}
                                                >
                                                    Re-publish <br /> Bounty
                                                </Menus.Button>
                                            </>
                                        )
                                    }
                                </Menus.List>
                            </Table.Row>
                        ))
                    ) : (
                        <NoDataAvailable />
                    )}
                    {totalEntries > 10 && (
                        <div className="w-[100%] mx-auto">
                            <Pagination
                                className="pt-6 pb-[.65rem]"
                                hoverColor="hover:text-textPrimary"
                                currentColor="bg-neutral50D"
                                textActive="text-textPrimary"
                                currentPage={currentPage}
                                totalPages={Math.ceil(totalEntries / entriesPerPage)}
                                entriesPerPage={entriesPerPage}
                                totalEntries={totalEntries}
                                entriesHandler={entriesHandler}
                                onPageChange={setCurrentPage}
                                border="border-borderUnderline"
                                hoverBorder="hover:border-borderUnderline"
                            />
                        </div>
                    )}
                </Table>
            </Menus >
            {
                isModalOpen && (
                    <div>
                        {modalAction === 'duplicate' && (
                            <DuplicateBountyModal
                                handleConfirmAction={handleConfirmAction}
                                bountyName={selectedBounty.title}
                                bountyId={selectedBounty._id}
                                close={handleCloseModal}
                            />
                        )}
                        {modalAction === 'start' && (
                            <StartBountyModal
                                handleConfirmAction={handleConfirmAction}
                                bountyName={selectedBounty.title}
                                bountyId={selectedBounty._id}
                                close={handleCloseModal}
                            />
                        )}
                        {modalAction === 'delete' && (
                            <DeleteBountyModal
                                onDelete={handleConfirmAction}
                                bountyName={selectedBounty.title}
                                bountyId={selectedBounty._id}
                                close={handleCloseModal}
                            />
                        )}
                        {modalAction === 'request' && (
                            <RequestTreasuryApprovalModal
                                handleConfirmAction={handleConfirmAction}
                                bountyName={selectedBounty.title}
                                bountyId={selectedBounty._id}
                                updatedTime={selectedBounty.updatedAt}
                                close={handleCloseModal}
                            />
                        )}

                        {modalAction === 'withdraw' && (
                            <WithdrawBountyModal
                                onWithdraw={handleConfirmAction}
                                bountyName={selectedBounty.title}
                                bountyId={selectedBounty._id}
                                close={handleCloseModal}
                            />
                        )}
                        {modalAction === 'expire' && (
                            <ForcefullyExpireBountyModal
                                onForcefullyExpire={handleConfirmAction}
                                bountyName={selectedBounty.title}
                                bountyId={selectedBounty._id}
                                close={handleCloseModal}
                            />
                        )}
                        {modalAction === 'extend' && (
                            <ExtendBountyDateModal
                                onExtend={handleConfirmAction}
                                bountyName={selectedBounty.title}
                                isValidationDateRequired={selectedBounty?.validationType === "ALL_TOGETHER"}
                                bountyId={selectedBounty._id}
                                close={handleCloseModal}
                            />
                        )}
                        {modalAction === 'republish' && (
                            <RePublishBountyModal
                                onRepublish={handleConfirmAction}
                                bountyName={selectedBounty.title}
                                isValidationDateRequired={selectedBounty?.validationType === "ALL_TOGETHER"}
                                bountyId={selectedBounty._id}
                                close={handleCloseModal}
                            />
                        )}
                    </div>
                )
            }
        </>
    );
}

export default BountiesList;
